export class TicketUrl {
  constructor({ url }: { url: string }) {
    this.url = url;
  }

  url: string;
}
